// MSTEM-MODIFIED: Runtime shim merging openblock-l10n editor-msgs with vi.json + mSTEM overrides.
// See .planning/phases/01-foundation-branding-i18n-vn/01-RESEARCH.md §"FND-03 sub-A".
//
// openblock-l10n@3.15.20250608130541 commented vi out of its supported-locales (line 66 of
// node_modules/openblock-l10n/src/supported-locales.js), so the runtime editor-msgs catalog
// only has en/ru/zh-cn/zh-tw. The vi.json source file IS shipped (511 keys, ~83% coverage).
// This shim merges vi.json + mSTEM-specific overrides and exposes a drop-in replacement
// for the `openblock-l10n/locales/editor-msgs` import used by src/reducers/locales.js.

import editorMessages from 'openblock-l10n/locales/editor-msgs';
import viInterface from 'openblock-l10n/editor/interface/vi.json';

// mSTEM-specific Vietnamese strings (override or fill gaps in vi.json).
// Decisions traceability:
//   D-13 Wiki link → 'Tài liệu mSTEM'
//   D-14 Tutorials label → 'Hướng dẫn sử dụng'
//   D-15 Community placeholder → 'Cộng đồng (sắp có)'
//   D-10 Coverage: fill gaps in vi.json where Plan-1-touched menu items lack translations
const mstemViOverrides = {
    'gui.menuBar.wiki': 'Tài liệu mSTEM',
    'gui.menuBar.community': 'Cộng đồng (sắp có)',
    'gui.menuBar.tutorialsLibrary': 'Hướng dẫn sử dụng',
    'gui.menuBar.noDeviceSelected': 'Chưa chọn thiết bị',
    'gui.menuBar.noConnection': 'Chưa kết nối'
};

// Unwrap the editor-msgs default export (handles both ESM `default` re-export and CJS bare object).
const baseMessages = editorMessages.default || editorMessages;

// Merge: produce a NEW object — never mutate the imported map.
const viMerged = Object.assign({}, viInterface, mstemViOverrides);

export default Object.assign({}, baseMessages, {vi: viMerged});
